import * as sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';

import 'moment/locale/nl';
import 'moment/locale/es';
import 'moment/locale/fr';

export const initializePlugins = () => {
	sentry.init({
		dsn: import.meta.env.VITE_SENTRY_SDN,
		integrations: [
			new sentry.BrowserTracing({
				tracePropagationTargets: ['localhost', 'api.ontreams.com'],
			}),
		],

		// We recommend adjusting this value in production, or using tracesSampler
		// for finer control
		tracesSampleRate: 0.1,
	});

	mixpanel.init(import.meta.env.VITE_MIXPANEL_API_TOKEN, { cross_subdomain_cookie: true });
};
